import { KFAutoCompleteProps } from '@kf/ic2fx';

export const getSearchResults = <T>(
  searchString: string,
  data: T[],
  optionConfig: KFAutoCompleteProps<T>['optionConfig'],
  page: number | null, // pagination
  count: number | null // for limit
) => {
  const results = { matchedData: [] as T[], matchedCount: 0 };

  /* istanbul ignore else */
  if (searchString?.trim() && data) {
    const matchedData = data.filter(
      (datum: any) =>
        datum?.[optionConfig.primaryKey]
          ?.toLowerCase()
          .includes(searchString?.toLowerCase()) ||
        (optionConfig.secondaryKey &&
          datum?.[optionConfig.secondaryKey]
            ?.toLowerCase()
            .includes(searchString?.toLowerCase())) //search the string in title and jobCode
    );

    results.matchedCount = matchedData.length;

    if (page != null && count != null && page > 0) {
      // if paging
      const start = page * count;
      const end = start + count;
      const slicedData = matchedData.slice(start, end);
      results.matchedData = slicedData;
    } else {
      results.matchedData = matchedData;
    }
  }
  return results;
};
